import { LoyaltyType } from "./loyalty-type.enum";
import { LoyaltyStatus } from "./loyalty-status.model";

export class AuctionState extends LoyaltyStatus{

    constructor(o?: Partial<AuctionState>){
        o = o || {};
        super(o);
        this.type = LoyaltyType.AUCTION;
    }
}